import React from "react";

const FileDocumentsBreadcrumbContext = React.createContext({
  selectedCategory: null,
  setSelectedCategory: () => {},
});

export default FileDocumentsBreadcrumbContext;
